import React from 'react';

const matchesRequest = (item, detail) => {
  const sameMongoId =
    item?._id != null &&
    detail?._id != null &&
    String(item._id) === String(detail._id);
  const sameCode =
    item?.id != null &&
    detail?.id != null &&
    String(item.id) === String(detail.id);
  return sameMongoId || sameCode;
};

export const useRecordOpenRequest = ({ event, items, onOpen, searchRef }) => {
  const itemsRef = React.useRef(items);
  const onOpenRef = React.useRef(onOpen);
  itemsRef.current = items;
  onOpenRef.current = onOpen;

  React.useEffect(() => {
    if (!event) return undefined;

    const handler = (e) => {
      const detail = e?.detail || {};

      if (detail.create) {
        window.requestAnimationFrame(() => {
          const el = searchRef?.current;
          if (el) el.focus();
        });
        return;
      }

      const match = (itemsRef.current || []).find((item) =>
        matchesRequest(item, detail)
      );
      if (match) onOpenRef.current?.(match);
    };

    window.addEventListener(event, handler);
    return () => window.removeEventListener(event, handler);
  }, [event, searchRef]);
};
